<div class="trinkavsGarmmarlyBanner">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="bannerContent">
                    <h1>Grammarly를 대신할 문법
                        <br>툴을 찾고 있나요?</h1>
                    <p>구독료 없이 Grammarly 프리미엄에서 Trinka로 전환하세요!</p>
                    <div class="bannerContentButtons try_a_free_form">
                        <!-- <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank" class="itsFreeButton">트링카 무료 사용
                        </a>
                        <span class="orTrydemoButton">
                            <a [routerLink]="['/try-a-demo']">
                                또는 데모 버전 사용
                            </a>
                        </span> -->
                        <form [formGroup]="compareTrinkaGrammarly" (ngSubmit)="onSubmitEmail()">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group" [ngClass]="(!compareTrinkaGrammarly.get('userEmailId').valid && compareTrinkaGrammarly.get('userEmailId').dirty) || (compareTrinkaGrammarly.get('userEmailId').touched && compareTrinkaGrammarly.get('userEmailId').pristine) ? 'TextFiledError' : '' ">
                                        <mat-form-field appearance="outline">
                                            <mat-label>이메일 입력 *</mat-label>
                                            <input id="contactUserEmail" matInput placeholder="" formControlName="userEmailId" class="form-control">
                                        </mat-form-field>
                                        <button type="submit">무료 이용</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarlyTestimonials">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonialsContent">
                    <img src="../../../assets/images/double_quotes_icon.png" alt="icon">
                    <p>트링카 AI 문법 검사 툴은 Grammarly를 능가합니다! 이전에 Grammarly로 검사했던 몇몇 문서를 다시 트링카로 검사했어요. 이 제품이 인도에서 개발되었다니 더욱더 놀랍고
                        기뻐요. 단연 Grammarly보다 우수해요.</p>
                    <h3>방사선 전문의, 인도</h3>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="switch_from_grammarly custom_width">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="grammarly_premium switchFromTrinka">
                    <h2>Grammarly Premium에서 트링카로
                        <br>변경해 보세요</h2>
                    <div class="HeadingSubLine"></div>
                    <p>이미 Grammarly Premium을 구독하고 있지만 더 나은 다른 툴을 찾고 계시나요? Grammarly Premium의 남은 구독 기간을 트링카 프리미엄으로 쉽게 변경 할 수
                        있습니다. </p>
                    <div class="sample_exmple">
                        <p>
                            <b>Grammarly프리미엄 연간 플랜 예시</b>
                        </p>
                        <p>프리미엄 시작일: 2021년 1월 5일</p>
                        <p>오늘 날짜: 2021년 4월 25일</p>
                        <p>무료로 추가 사용 가능한 일자: 255일</p>
                    </div>
                    <div class="how_it_work">
                        <a (click)="scroll(target)" class="itsFreeButton">사용방법 확인하기
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="free_premium">
                    <div class="free_premium_border">
                        <div class="discount-label yellow">
                            <span>스페셜 오퍼</span>
                        </div>
                        <div class="free_premium_title">
                            무료 프리미엄
                            <br />연장일 확인
                        </div>
                        <i>해당 계산기를 이용하여, Grammarly에서 트링카 프리미엄으로 변경할 때 받을 수 있는 무료 연장 구독 기간을 확인해 보세요.</i>
                        <div class="free_premium_form">
                            <!-- <form> -->
                            <div class="textbox_content form-group">
                                <label>Grammarly프리미엄 시작일:</label>
                                <input placeholder="MM/DD/YY" type="date" class="form-control" (change)="premiumDateChanged($event)">
                                <label>플랜 유형</label>
                                <select class="custom-select" [ngModel]="grammarlySelect" (change)="planTypeChanged($event)">
                                    <option selected value="">플랜 유형</option>
                                    <option value="M">월간</option>
                                    <option value="Y">연간</option>
                                </select>
                            </div>
                            <!-- </form> -->
                            <p *ngIf="finalTextContent" class="form_status">You will get
                                <span>{{diffDays}}</span> additional days if you buy Trinka Premium annual plan today ({{currentDate
                                | date:'dd-MM-yyyy'}}).
                            </p>
                            <!-- <h3>Example for Grammarly Premium Annual Plan</h3>
                            <p>Premium start date:  5 January 2021</p> 
                            <p>Today's date: 25 April 2021</p> 
                            <p>Addition free days you will get: 255 days</p> 
                            <h3 class="mart15">Example for Grammarly Premium Monthly Plan</h3>
                            <p>Premium start date:  5 January 2021</p> 
                            <p>Today's date: 25 January 2021</p> 
                            <p>Addition free days you will get: 20 days</p>  -->
                        </div>
                        <span class="validTextSection">*직불/신용카드를 통한 결제 시에만 유효합니다</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="writing_need_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="compare_tables_discriptions">
                    <h2>Trinka vs Grammarly 자세한 비교</h2>
                    <div class="HeadingSubLine"></div>
                    <p>아래 내용을 통해 트링카가 어드밴스 레벨의 영어 문법 검사, 철자 검사, 영어 작문 개선 측면에서 Grammarly보다 어떤 부분이 더 우수한지 비교 가능합니다. </p>
                </div>
                <div class="compare_tabels table-responsive">
                    <table class="table">
                        <tr>
                            <th>특성</th>
                            <th>Trinka</th>
                            <th>Grammarly</th>
                        </tr>
                        <tr>
                            <td>
                                학술 스타일 가이드
                                <b>(APA, AMA 등 포함)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                주제별 교정
                                <b>(의학, 생명 과학, 공학 등)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                기술적 철자
                                <b>(주제에 따른 철자 교정)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                기술적 문장
                                <b>(주제에 적절한 작문)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                모호한 언어
                                <b>(글을 명확하게 구체적으로 작성해 주세요.)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                출판 가능 여부 체크
                                <b>(성공적인 출판을 위한 20가지 이상의 체크포인트 평가)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                자동 파일 교정
                                <b>(자동으로 몇 분 내 MS 워드 파일을 교정)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="icon">
                            </td>
                        </tr>

                        <tr>
                            <td>
                                격식 있는 / 학술적 어조
                                <b>(구어체, 일상적인 구동사, 속담 등 포함)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <span class="LimitedContent">Limited
                                    <button class="tooltip_section AcademicTone" alt="축약어, 1인칭 대명사 및 수동태와 같은 몇 유형의 학문적 어조 기능으로 제한됩니다. Trinka는 이 외에도 구어체와 구동사 및 관용구를 다룹니다.">
                                        <img src="../../../assets/images/info.svg" alt="icon" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>단어 수 삭감
                                <b>(간결하고 효과적인 작문)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <span class="LimitedContent">Limited
                                    <button class="tooltip_section" alt="복합 전치사 및 반복과 같은 몇 유형의 간결함과 관련된 기능으로 제한됩니다. Trinka는 명사화 어미를 간결하고 직접적으로 만드는 방법을 보여주고 단어뿐 아니라 구두점을 포함하여 단어 수를 축소하는 방안을 제공합니다. ">
                                        <img src="../../../assets/images/info.svg" alt="icon" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>편파적이지 않은 언어 사용
                                <b>(포괄적, 사람 우선적, 비성차별적인 언어 사용)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <span class="LimitedContent">Limited
                                    <button class="tooltip_section UnbiasedLanguage" alt="폭넓은 언어를 포함하여 몇 유형의 편파적이지 않은 언어 기능으로 제한됩니다. Trinka는 이 문제를 다루고 글이 사람 우선적이고 비성차별적인 언어를 반영하는지 확인합니다.">
                                        <img src="../../../assets/images/info.svg" alt="icon" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                표절 검사
                                <b>(인터넷, 오픈액세스 및 유료 게시 콘텐츠 대상 검사)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td  class="single-line-tootltip">
                                <span class="LimitedContent">Limited
                                    <button class="tooltip_section UnbiasedLanguage" alt="유료 게시 콘텐츠 불포함">
                                        <img src="../../../assets/images/info.svg" alt="icon" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                일관성 체크
                                <b>(대쉬 사용, 철자, 수치 등)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>모든 변경 수락 또는 거절
                                <b>(클릭 후 여러 부분 제안을 적용 또는 무시할 수 있습니다.)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>고급 문법 체크</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>문장 구조 교정</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>단어 선택</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>미국/영국 영어 스타일</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>자세한 설명 & 팁</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>개인용 사전</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>온라인 에디터</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>브라우저 플러그인</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>
                        <tr>
                            <td>MS 워드 플러그인</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="icon">
                            </td>
                        </tr>

                    </table>
                </div>
                <div class="disclaimerContainer disclaimerContainer_table">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="disclaimercontents">
                                    <p>학생, 교수, 사서 및 교육자의 필요에 가장 적합한 참조 생성기는 무엇인지 충분한 정보를 바탕으로 결정을 내릴 수 있도록 비교 차트를 만들었습니다. 이
                                        차트에 오류가 있거나 누락된 정보가 있다면
                                        <a href="mailto:support@trinka.ai">이메일</a> 을 보내주시면 수정하겠습니다.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="try_trinka_Buttons">
                    <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">트링카 무료 사용</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="pricing_plan">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="pricing_plan_tables">
                    <h2>서비스 비용</h2>
                    <div class="HeadingSubLine"></div>
                    <p>모든 기능을 비교하고 직접 확인하세요! Trinka는 일반적인 문법 확인 툴이 아닌 학술 및 기술적 작문에 가장 적합한 툴입니다. </p>
                </div>
                <div class="compare_tabels table-responsive">
                    <div class="pricing_plan_details">
                        <div class="pricing_details">
                            <div class="plan_name">
                                <div class="plan_name_left">
                                    <label>Trinka
                                        <br>Free</label>
                                    <div class="pricing">
                                        <div class="price">
                                            $0
                                            <b>/ month</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan_name_right">
                                    <img src="../../../assets/images/trinka-logo.png" alt="trinka" width="136">
                                </div>
                            </div>
                            <ul>
                                <li>맥락과 관련된 스펠링 체크</li>
                                <li>어드밴드 문법 체크</li>
                                <li>라이팅 톤 수정</li>
                                <li>문장 구조 수정</li>
                                <li>라이팅 효과 향상</li>
                                <li>자동 파일 편집</li>
                                <li>기술적인 단어 선택</li>
                                <li>논문 스타일에 따른 가이드</li>
                                <li>일관성 체크</li>
                                <li>표절 검사</li>
                                <li>출판 준비를 위한 라이팅
                                    <br>
                                    <small>(기술적인 표현, 단어 수 감소 etc.)</small>
                                </li>
                                <li>논문 출판 준비
                                    <br>
                                    <small>(저널 범위 검사, 논문 요약 etc.)</small>
                                </li>
                            </ul>
                        </div>
                        <div class="pricing_details">
                            <div class="plan_name">
                                <div class="plan_name_left">
                                    <label>Grammarly Premium</label>
                                    <div class="pricing">
                                        <div class="price">
                                            $12
                                            <b>/ month</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan_name_right">
                                    <img src="../../../assets/images/grammarly-logo.png" alt="grammar" width="150px">
                                </div>
                            </div>

                            <ul>
                                <li>철자</li>
                                <li>문법, 구두점 및 유창성</li>
                                <li>어조 조정</li>
                                <li>명확성 중심의 문장 교정</li>
                                <li>문장 교정 예시</li>
                                <li>자동으로 문장 교정.</li>
                                <li>단어 선택</li>
                                <li>추가적인 고급 제안</li>
                            </ul>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="trinkaBetterThanOthers">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="betterThenContent">
                    <h2>트링카가 Grammarly를 비롯한 주요 문법 검사 툴보다 더 우수한 이유는 무엇인가요?</h2>
                    <div class="HeadingSubLine"></div>
                    <p>어드밴스 영어 문장 작성에 고급 검사가 필요하다면 트링카가 안성맞춤입니다. 트링카는 AI 기반으로 설계된 문법 검사 및 언어 수정 툴로서 형식 언어 및 글쓰기 기술에 최적화되어
                        <br>있습니다. 따라서 트링카는 문법과 철자, 구두점을 수정할 뿐만 아니라 글의 품질을 높여
                        <br>출판 성공 가능성을 극대화해 주는 혁신적인 툴입니다.</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="betterThenImg">
                    <img src="../../../assets/images/BetterThen_img.png" alt="better">
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writing_need_sections">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject">
                        <h3>주제 분야 & 문서 유형</h3>
                    </div>
                    <p>Trinka를 맞춤 설정하여 주제 분야 및 원고 유형을 바탕으로 관련성이 높은 제안을
                        <br>받아보세요.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="style_guide">
                        <h3>스타일 가이드 선호 사항</h3>
                    </div>
                    <p>일반적인 학술 스타일 가이드(AMA 11th, APA 7th)를 준수하도록 원고의 문법 및 단어 선택을 교정하세요. </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/autoFileEdit_icon.svg" alt="auto-file-edit">
                        <h3>자동 파일 교정</h3>
                    </div>
                    <p>MS 워드 문서를 업로드하고 Trinka가 몇 분 내에 자동으로 교정을 진행하는 동안 편안히 앉아계세요. 완료된 문서를 다운로드하고 완료하세요.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/Icon_PublicationChecks.png" alt="publication" style="max-width: 30px;">
                        <h3>출판 가능 여부 체크</h3>
                    </div>
                    <p>출판 가능성을 높이기 위해 저널 셀렉션부터 윤리 규정 준수에 이르기까지 20개
                        <br>이상의 체크포인트에 따라 문서를 평가
                        <br>하세요. </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove paddingRightRemove">
                <div class="features_cards commingSoonTag">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/ConsistencyCheck_icons.png" alt="consistency-check" style="max-width: 30px;">
                        <h3>일관성 체크
                        </h3>
                    </div>
                    <p>Trinka의 일관성 검사를 통해 문서의 길이에 상관없이 전체 텍스트에서 6가지
                        <br>유형의 불일치를 감지하고 클릭 한 번
                        <br>으로 수정할 수 있습니다.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/DownloadTrackChangesEdit_icon.png" alt="download" style="max-width: 22px;">
                        <h3>다운로드 변경 추적 파일</h3>
                    </div>
                    <p>Trinka 에디터에서 선택한 다양한 변경
                        <br>사항을 보여주는 변경 추적 파일을
                        <br>다운로드하고 완료하세요. </p>
                </div>
            </div>



        </div>
    </div>
</div>
<div class="professionalAcademic">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2>전문적인 학술 및 기술적 문법 교정
                </h2>
                <div class="HeadingSubLine"></div>
                <p>Trinka AI는 3000가지 이상의 문법 검사, 어조 및 스타일 향상, 고급 작문 팁을 제공하며 무엇보다 학술 및 기술적 작문과 관련된 모든 주제에 사용 가능합니다.</p>
                <div class="grammarCorrectionSlide">

                    <div class="grammarCorrectionMain">

                        <!-- <div class="sliderHeading">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="icon">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The beautiful part of this writing assistant, is one it works very fast
                                                            quickly, secondly second it doesn’t <b>requires</b>&nbsp;
                                                            <span>require</span> any effort from the writer.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="icon">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The beautiful part of this writing assistant, is one it works <b>very
                                                                fast</b>&nbsp;<span>quickly,</span> secondly second it <b>doesn’t
                                                                requires</b>&nbsp;<span>does not require</span> any effort from the
                                                            writer.</p>
                                                    </div>
                                                </div>
                                            </div>
            
                                        </div>
                                    </div> -->
                        <div class="carousel slide" id="keyBenefitContentTwo" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#keyBenefitContentTwo" data-slide-to="0" class="active"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="1"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="2"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="3"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="4"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="5"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="6"></li>
                            </ol>

                            <div class="carousel-inner">

                                <div class="carousel-item active">
                                    <div class="original-text">
                                        <i>원본</i>
                                        <p>Brazilian soils has low levels of phosphorus available, due to high acidity, therefore,
                                            are fundamental the application of phosphate fertilizers for high yields.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammar">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Brazilian soils
                                                            <b>has</b>&nbsp;
                                                            <span>have</span> low
                                                            <b>levels of</b> phosphorus
                                                            <span>levels</span> available
                                                            <b>,</b> due to high acidity, therefore, are fundamental the application
                                                            of phosphate fertilizers for high yields.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Brazilian soils
                                                            <b>has</b>&nbsp;
                                                            <span>have</span> low levels of phosphorus
                                                            <b>available, due to </b>&nbsp;
                                                            <span>because of</span> high acidity,
                                                            <span>and </span>therefore, are fundamental
                                                            <span>to</span> the application of phosphate fertilizers for high yields.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>원본</i>
                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply, is a major cause
                                            of death and affect annually approximately 795,000.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply,
                                                            is a major cause of death and
                                                            <b>affect</b>&nbsp;
                                                            <span>affects</span>&nbsp;annually approximately 795,000.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka_logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply,
                                                            is a major cause of death and
                                                            <b>affect annually </b>&nbsp;
                                                            <span>annually affects </span> approximately 795,000.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>원본</i>
                                        <p>The depleted proteins were finally digested by trypsin at a protein/trypsin ratio
                                            (w/w) of 50:1 at 37°C for overnight.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The depleted proteins were finally digested by trypsin at a protein/trypsin
                                                            ratio (w/w) of 50:1 at 37°C for overnight.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka_logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The depleted proteins were finally digested
                                                            <b>by</b>&nbsp;
                                                            <span>with</span> trypsin at a protein/trypsin ratio (w/w) of 50:1
                                                            at 37°C
                                                            <b>for</b> overnight.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>원본</i>
                                        <p>Belladonna leaves as well as all other studied leaves contains two distinct phosphatase
                                            fraction belonging to types II and III.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Belladonna leaves, as well as all other studied leaves
                                                            <span>,</span>
                                                            <b>contains</b>
                                                            <span>contain</span>
                                                            &nbsp;two distinct phosphatase
                                                            <b>fraction</b>
                                                            <span>fractions</span> belonging to types II and III. </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka_logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Belladonna leaves
                                                            <b>as well as all</b>&nbsp;
                                                            <span>and </span> other
                                                            <b>studied</b> leaves
                                                            <span>being studied </span>
                                                            <b>contains</b>
                                                            <span>contain</span>&nbsp;two distinct phosphatase
                                                            <b>fraction</b>
                                                            <span>fractions </span>belonging to types II and III.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>원본</i>
                                        <p>He sees signs of long term starvation, worse even than what he saw in Arkansas.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>He sees signs of
                                                            <span>long term</span>
                                                            <b>long-term</b> starvation, worse even than what he saw in Arkansas.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka_logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>He sees signs of
                                                            <span>long term</span>
                                                            <b>long-term</b> starvation,
                                                            <span>even</span> word
                                                            <b>even</b> than what he saw in Arkansas.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>원본</i>
                                        <p>This kind of political torn-foolery has to a considerable extend prevented our movies
                                            from examining the actual problems of success.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>This kind of political torn-foolery has to a considerable extend
                                                            prevented our movies from examining the actual problems of success.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka_logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>
                                                            <b>This kind of</b>
                                                            <span>Such</span> political
                                                            <b>torn-foolery</b>
                                                            <span>tomfoolery</span> has to a considerable
                                                            <b>extend</b>
                                                            <span>extent</span> prevented our movies from examining the actual
                                                            problems of success.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>원본</i>
                                        <p>The results shows 234 differently expressed proteins (DEP) between GBM to normal
                                            brain tissues.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt=grammarly"">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The results
                                                            <b>shows</b>
                                                            <span>show</span> 234 differently expressed proteins (DEP) between
                                                            GBM to normal brain tissues.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka_logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The results
                                                            <b>shows</b>
                                                            <span>show</span> 234
                                                            <b>differently</b>
                                                            <span>differentially</span> expressed proteins (
                                                            <b>DEP</b>
                                                            <span>DEPs</span>) between GBM
                                                            <b>to</b>
                                                            <span>and</span>&nbsp;normal brain
                                                            <b>tissues</b>
                                                            <span>tissue</span>.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="compare_top_tools">
    <div class="container">
        <div class="row">
            <div class="col-lg-5">
                <div class="top_tools_image">
                    <img src="../../../assets/images/top_tools_compare.png" alt="compare_tools">
                </div>
            </div>
            <div class="col-lg-7">
                <div class="top_tools_text_contents">
                    <div class="howItWorkHeading lineWhiteColor">
                        <h3>주요 문법 검사 툴과 트링카 기능 비교</h3>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <p>Grammarly, LanguageTool, Ginger 등 다른 주요 온라인 문법 툴에 비해 어떤 기능으로 트링카가 더 우수한지 확인하기 위해 다음과 같은 테스트를 진행하였습니다.
                        5개 학술분야에서 추출한 5,778단어로 글 수정의 정확도, 스타일 가이드의 선호 사항, 간결함, 문맥에 맞는 철자 검사 등이 비지니스 및 글쓰기 기술에 중점을 두고, 이를
                        기준으로 평가했습니다. 자세한 비교는 백서를 통해 확인 가능합니다.</p>
                        <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']" style="cursor: pointer;">
                        백서 다운로드
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="meetTrinka_sections">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="meetTrinka_heading">
                    <h2>높은 품질의 영어 문장 작성을 위해 어드밴스 레벨로 체크하는건 필수, 트랑키를 통해 확인해 보세요. </h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <div class="meetTrinkaCard">
                    <div class="meetTrinka_img">
                        <img src="../../../assets/images/GoBeyondGrammar&Spelling.svg" alt="image">
                    </div>
                    <h3>문법과 철자 검사 차원 능가</h3>
                    <p>트링카는 차세대 문법 검사 툴의 차원을 능가하여 까다로운 학술 문장의 오류도 다른 어느 툴보다 명확하게 잘 찾아냅니다.
                        <br>따라서 개인 맞춤형 글쓰기 보조 툴로도
                        <br>아주 적합합니다. </p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="meetTrinkaCard unmatched_sections">
                    <div class="meetTrinka_img">

                        <img src="../../../assets/images/UnmatchedWritingEnhancements.svg" alt="enhancement">
                    </div>
                    <h3>비교 불과한 영어 작문 개선</h3>
                    <p>트링카는 학술 출판 표준에 부합하도록
                        <br>글의 어조와 전달력, 문장을 개선합니다.
                    </p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="meetTrinkaCard learnAndHelps">
                    <div class="meetTrinka_img">
                        <img src="../../../assets/images/Learns&HelpsYou.svg" alt="learn">
                    </div>
                    <h3>더 나은 저자가 되도록 지원</h3>
                    <p>트링카는 폭넓은 설명, 제안, 영어 작문 조언을 제공하므로 저자는 글 작성에 대해 배우고 원고의 품질 또한 개선할 수 있습니다. </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="meetTrinka_sections switchToTrinka padt0" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="meetTrinka_heading">
                    <h2>Grammarly Premium에서 트링카로 변경해 보세요.</h2>
                    <div class="HeadingSubLine"></div>
                    <p>이미 Grammarly Premium을 구독하고 있지만 더 나은 다른 툴을 찾고 계시나요? Grammarly Premium의 남은 구독 기간을 트링카 프리미엄으로 쉽게 변경 할 수
                        있습니다. </p>
                    <p>지금 Trinka로 전환하고 학술 및 기술적 작문을 위해 특별히 설계된 고급 문법 수정 및 여러 기능을 사용해 보세요.</p>
                    <p>지금 3가지 간단한 단계를 따라 해보세요.</p>
                </div>
            </div>
        </div>
        <div class="key_takewaye_sections">
            <h2>어떻게 진행되나요?</h2>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>1</p>
                        </div>
                        <div class="need_cards_body">
                            <p>
                                <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">"무료 등록"</a> 을 클릭하여 계정을 만드세요. 학술 및 기술적 작문을 위해 특별히 준비된 다양한 기능을 사용해 보세요. </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>2</p>
                        </div>
                        <div class="need_cards_body">
                            <p> Trinka 프리미엄을 구독하려면 "업그레이드"를 선택하세요. 연간 요금제를 선택하고 결제하세요.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>3</p>
                        </div>
                        <div class="need_cards_body">
                            <p>
                                <a href="mailto:support@trinka.ai">support@trinka.ai</a>로 Grammarly Premium의 세부 정보를 보내주시면 Grammarly Premium의 남은 구독 기간을 트링카 프리미엄으로
                                <br>전환해 드립니다.</p>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-12">
                    <p class="disclaimer-txt">주문 한 건에 대해 쿠폰, 할인,  또는 프로모션에서 한 번만 사용할 수 있습니다.</p>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>Trinka와 함께 더 나은 작문을 경험하세요.</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span>무료로 등록하세요</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="other_comparision">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. Ginger</h3>
                    </div>
                    <p>Trinka와 함께 문법과 철자 체크를 넘어
                        <br>작문을 향상시키세요.</p>
                    <a [routerLink]="['/trinka-vs-ginger']">더 알아보기
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. LanguageTool</h3>
                    </div>
                    <p>Trinka와 함께 전체적인 언어 향상을 경험하세요.</p>
                    <a [routerLink]="['/trinka-vs-languagetool']">더 알아보기
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. Writefull</h3>
                    </div>
                    <p>Trinka와 함께 학술 작문의 관습과 모범
                        <br>사례들을 만나보세요.</p>
                    <a [routerLink]="['/trinka-vs-writefull']">더 알아보기
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="disclaimerContainer">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="disclaimercontents">
                    <p>
                        <span>면책 조항:</span> 모든 제품 및 회사 이름은 해당 소유자의 상표™ 또는 등록 상표이며 해당 제품 또는 회사 이름의 사용은 제휴 또는 보증을 의미하지 않습니다. 언급된
                        모든 비교 사항은 제품 브로슈어/웹사이트에서 제공되는 제품 정보와 2021년 9월 15일 기준의 동일한 조건에서 실제 테스트를 기반으로 작성되었습니다. 질문이 있는 경우
                        <a href="mailto:support@trinka.ai">support@trinka.ai</a>로 문의하십시오.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>